<template>
  <Agreement/>
</template>
<script>
import Agreement from 'place/login/agreement.vue'
export default {
    components:{
      Agreement
    }
}
</script>